<h1>Welcome, {{ customerName }}!</h1>
<div class="chart-section">
  <!-- <div echarts [options]="chartOptions1"></div>
  <div echarts [options]="chartOptions2"></div> -->
</div>
<div class="table-section">
  <bodyanalytics-generic-table [columns]="columns" [rows]="data"></bodyanalytics-generic-table>
</div>
